export const signinPasswordRegex = /^(?=.*[a-z])(?=.*\d).{8,}$/i;

export async function signinPasswordValidate(value: string): Promise<boolean> {
  return signinPasswordRegex.test(value);
}
